export default "<app-form></app-form>\n<mat-divider></mat-divider>\n<app-table></app-table>\n"